const deviceMessages = {
  'device.title': 'デバイス管理',
  'device.DeviceLists.title.deviceNickname': 'デバイス表示名',
  'device.DeviceLists.title.deviceName': 'デバイス名',
  'device.DeviceLists.title.deviceSerial': '端末シリアル',
  'device.DeviceLists.title.deviceUseNum': '利用人数',
  'device.DeviceDetail.title': 'デバイス情報更新',
  'device.DeviceDetail.title.deviceNickname': 'デバイス表示名',
  'device.DeviceDetail.title.deviceName': 'デバイス名',
  'device.DeviceDetail.title.deviceSerial': '端末シリアル',
  'device.DeviceDetail.title.deviceUserName': '利用者',
  'device.DeviceDetail.deviceNickname.placeholder':
    'デバイス表示名を入力してください',
  'device.DeviceDetail.deviceUserName.defaultUse': 'デフォルト利用',
  'device.DeviceDetail.button.update': '更新',
};

export default deviceMessages;
